export const quantiles = (root) => root
